<div class="dialogs-shadow" [@openState]="state" (@openState.done)="dialogClosed($event)"></div>
<div #dialogsPlaceholder></div>